import type { FunctionComponent, ReactNode } from 'react';

import { MediaFileUpload } from 'components/admin';

import type { AssetT } from 'utils';

import { Item } from './Item';

import './style.scss';

type PropsT = {
  assets: AssetT[];
  localFiles: File[];
  onUse: (item: AssetT | File) => void;
  removeAsset: (asset: AssetT) => void;
  setLocalFiles: (files: File[]) => void;
};

export const Library: FunctionComponent<PropsT> = ({
  assets,
  localFiles,
  onUse,
  removeAsset,
  setLocalFiles,
}) => {
  const nodes: ReactNode[] = [];

  for (let i = localFiles.length - 1; i >= 0; --i) {
    const file = localFiles[i];
    if (!file) throw Error('Internal error');

    nodes.push(
      <Item
        data={file}
        key={`local-file/${i}`}
        onRemove={() => {
          const files = localFiles.slice();
          files.splice(i, 1);
          setLocalFiles(files);
        }}
        onUse={() => {
          onUse(file);
        }}
      />,
    );
  }

  for (const asset of assets) {
    nodes.push(
      <Item
        data={asset}
        key={asset.id}
        onRemove={() => {
          removeAsset(asset);
        }}
        onUse={() => {
          onUse(asset);
        }}
      />,
    );
  }

  return (
    <div styleName="container">
      <MediaFileUpload
        assets={[]}
        files={[]}
        localFiles={localFiles}
        removeAsset={() => undefined}
        removeFile={() => undefined}
        setLocalFiles={setLocalFiles}
        withoutUploadedFilesInfo
      />
      <div styleName="items">{nodes}</div>
    </div>
  );
};
